import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TslSessionService } from 'projects/aztalena-core/src/public-api';
import { map, tap } from 'rxjs/operators';
import { UserInfo } from 'src/app/user-info';
import { UserInfoService } from './user-info.service';

export const adminAuthGuard: CanActivateFn = () => {
  const session = inject(TslSessionService);
  const router = inject(Router);
  const user = inject(UserInfoService);

  if (!session.accessToken) {
    router.navigate(['sign-in']);
    return false;
  }

  return user.getUserInfo().pipe(
    tap((info) => {
      if (info.permission === 0) {
        router.navigate(['sign-in']);
      }
    }),
    map((info: UserInfo) => info.permission === 1)
  );
};
